import { Paper } from "@mantine/core";
import { ComponentTabs } from "../ComponentTabs/ComponentTabs";

export const COMPONENTS_PANEL_ID = "components-panel";
interface ComponentsPanelProps {
  projectId: string;
  siteId: number;
  variantId: number;
  graphCoordinates: { x: number; y: number };
  setShowNotAccessibleModal: (show: boolean) => void;
}

function ComponentsPanel({
  projectId,
  siteId,
  variantId,
  graphCoordinates,
  setShowNotAccessibleModal
}: ComponentsPanelProps) {
  return (
    <Paper id={COMPONENTS_PANEL_ID}>
      <ComponentTabs
        graphCoordinates={graphCoordinates}
        projectId={projectId}
        setShowNotAccessibleModal={setShowNotAccessibleModal}
        siteId={siteId}
        variantId={variantId}
      />
    </Paper>
  );
}

export { ComponentsPanel };
